import { checkValueTypeUsesVariable } from '../../utilities';
import { ChangeFieldValueStep } from '../actionSectionTypes';

export const changeFieldValueRemoveVariable = (
  step: ChangeFieldValueStep,
  variableName: string,
  errorIds?: string[]
) => {
  let hasError = step.hasError || false;
  const nextErrorIds: string[] = [];
  let allFieldErrors: Record<string, any> = step.details.allFieldErrors;

  const actions = step.details.actions.map((action) => {
    if (
      checkValueTypeUsesVariable(action.changeType?.value) &&
      action.variable?.value === variableName
    ) {
      if (!nextErrorIds.includes(step.id) && !nextErrorIds.includes(step.id)) {
        hasError = true;
        nextErrorIds.push(step.id);
      }

      const actionError = {
        ...(allFieldErrors?.[action.key] || {}),
        variable: true,
      };
      allFieldErrors = { ...allFieldErrors, [action.key]: actionError };

      return {
        ...action,
        variable: { ...action.variable, deleted: true },
      };
    }
    return action;
  });

  return {
    nextStep: {
      ...step,
      details: {
        ...step.details,
        actions,
        allFieldErrors,
      },

      hasError,
    },
    nextErrorIds,
  };
};
